import { Careers, CareersActionTypes } from './types';
import { createAsyncAction } from '~lib/shared/redux/actions';

export const getCareers = createAsyncAction<void, Careers>(CareersActionTypes.GET_CAREERS);
